export default {
      id: "icon-google-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "icons.svg#icon-google",
      toString: function () {
        return this.url;
      }
    }